import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	recordANewVideo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newLoomVideo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loomVideo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	videoIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tryLozenge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addLozenge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newLozenge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recordANewVideo: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.record-a-new-video',
		defaultMessage: 'Record a video',
		description: 'Click on this item to trigger Loom SDK to start recording a Loom video',
	},
	newLoomVideo: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.new-loom-video',
		defaultMessage: 'New Loom video',
		description:
			'Click on this item to trigger Loom SDK to start recording a Loom video, quick actions menu GA experiment only',
	},
	loomVideo: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.loom-video',
		defaultMessage: 'Loom video',
		description:
			'The user who does not have loom access, click on this item to join loom and start recording, quick actions menu GA experiment only',
	},
	loading: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.loading',
		defaultMessage: 'Loading',
		description:
			'The aria-label attribute for the spinner on the Loom record menu item in the Loom section',
	},
	videoIcon: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.video-icon',
		defaultMessage: 'Video icon',
		description:
			'The aria-label attribute for the VideoIcon component in the Loom record menu item in the Loom section',
	},
	tryLozenge: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.try-lozenge',
		defaultMessage: 'Try',
		description:
			'Lozenge to ask users to try an existing Loom product on the site and start a video recording',
	},
	addLozenge: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.add-lozenge',
		defaultMessage: 'Add',
		description:
			'Lozenge to ask users to try an existing Loom product on the site and start a video recording (experimental)',
	},
	newLozenge: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.new-lozenge',
		defaultMessage: 'New',
		description:
			'Lozenge to tell users the Loom product is new on the site and user can start a video recording',
	},
});
export default messages;
